import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RootGate } from "@/components/RootGate";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import DocumentsList from "@/pages/DocumentsList";
import Counterparties from "@/pages/Counterparties";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import PublicDocumentView from "@/pages/PublicDocumentView";
import VerifyDocument from "@/pages/VerifyDocument";
import AuditLog from "@/pages/AuditLog";
import Projects from "@/pages/Projects";
import CalendarPage from "@/pages/Calendar";
import PlatformAdminDashboard from "@/pages/PlatformAdminDashboard";
import AboutCompany from "@/pages/AboutCompany";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors offset={{ top: "72px" }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/view/:token" element={<PublicDocumentView />} />
          <Route path="/verify" element={<VerifyDocument />} />
          <Route path="/verify/:code" element={<VerifyDocument />} />
          <Route path="/about" element={<AboutCompany />} />
          <Route path="/platform-admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/platform-admin" element={<PlatformAdminDashboard />} />
          <Route path="/" element={<RootGate />}>
            <Route index element={<Dashboard />} />
            <Route path="documents/:direction" element={<DocumentsList />} />
            <Route path="counterparties" element={<Counterparties />} />
            <Route path="reports" element={<Reports />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="projects" element={<Projects />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="team" element={<Team />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
